import GoogleIcon from '@mui/icons-material/Google';
import PsychologyIcon from '@mui/icons-material/Psychology';
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';

const icon = (name) => <SvgColor src={`/assets/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  users: icon('users'),
  whatsApp: icon('whatsApp'),
  partners: icon('partners'),
  accountSetup: icon('accountSetup'),
  reports: icon('reports'),
  whitelable: icon('whitelable-setup'),
  profile: icon('profile'),
};

const whatsappDemoUrl = new URL(window.location.href);

const partner_type = 'whitelabel';

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    // subheader: 'general v4.1.0',
    items: [
      { title: 'Customers', path: PATH_DASHBOARD.customers.root, icon: ICONS.users },
      (partner_type === 'whitelable' || partner_type === 'whitelabel') && {
        title: 'Partners',
        path: PATH_DASHBOARD.partners.root,
        icon: ICONS.partners,
      },
      (partner_type === 'whitelable' || partner_type === 'whitelabel') && {
        title: 'Google Workspace',
        path: PATH_DASHBOARD.googleWorkspace.root,
        icon: <GoogleIcon />,
        children: [
          {
            title: 'Customers',
            path: PATH_DASHBOARD.googleWorkspace.customers,
          },
          {
            title: 'Transactions',
            path: PATH_DASHBOARD.googleWorkspace.transactions,
          },
        ],
      },
      {
        title: 'WhatsApp',
        path: PATH_DASHBOARD.whatsApp.root,
        icon: ICONS.whatsApp,
        children: [
          (partner_type === 'whitelable' || partner_type === 'whitelabel') && {
            title: 'Partners',
            path: PATH_DASHBOARD.whatsApp.partners,
          },
          {
            title: 'Customers',
            path: PATH_DASHBOARD.whatsApp.customers,
          },
          (partner_type === 'whitelable' || partner_type === 'whitelabel') && {
            title: 'Transactions',
            path: PATH_DASHBOARD.whatsApp.transactions,
          },
          (partner_type === 'whitelable' || partner_type === 'whitelabel') && {
            title: 'Templates',
            path: PATH_DASHBOARD.whatsApp.templates,
          },
          {
            title: 'Demo',
            path: PATH_DASHBOARD.whatsApp.demo.root,
            children: [
              {
                title: 'Start Demo',
                path: `${whatsappDemoUrl.origin}/whatsapp/demo`,
              },
              ...(partner_type === 'whitelable' || partner_type === 'whitelabel'
                ? [
                    {
                      title: 'Customize Demo',
                      path: PATH_DASHBOARD.whatsApp.demo.customize,
                    },
                    {
                      title: 'Demo Records',
                      path: PATH_DASHBOARD.whatsApp.demo.records,
                    },
                  ]
                : []),
            ],
          },
          {
            title: 'Fix Display Name',
            path: PATH_DASHBOARD.whatsApp.fixDisplayName,
          },

          // {
          //   title: 'Rates',
          //   path: PATH_DASHBOARD.whatsApp.rates,
          // },
          // {
          //   title: 'Settings',
          //   path: PATH_DASHBOARD.whatsApp.settings,
          // },
        ],
      },
      {
        title: 'Google My Business',
        path: PATH_DASHBOARD.googleMyBusiness.root,
        icon: <PsychologyIcon />,
        children: [
          {
            title: 'Partners',
            path: PATH_DASHBOARD.googleMyBusiness.partners,
          },
          {
            title: 'Customers',
            path: PATH_DASHBOARD.googleMyBusiness.customers,
          },
          {
            title: 'Transactions',
            path: PATH_DASHBOARD.googleMyBusiness.transactions,
          },
          {
            title: 'Transaction Invoice',
            path: PATH_DASHBOARD.googleMyBusiness.transactionInvoice,
          },
          {
            title: 'Setup API Key',
            path: PATH_DASHBOARD.googleMyBusiness.setupApiKey,
          },
        ],
      },
      (partner_type === 'whitelable' || partner_type === 'whitelabel') && {
        title: 'Reports',
        path: PATH_DASHBOARD.reports,
        icon: ICONS.reports,
      },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    items: [
      (partner_type === 'whitelable' || partner_type === 'whitelabel') && {
        title: 'Teams',
        path: PATH_DASHBOARD.teams.root,
        icon: ICONS.users,
      },
      {
        title: 'Partner Profile',
        path: PATH_DASHBOARD.partners.partnerProfile,
        icon: ICONS.profile,
      },
      (partner_type === 'whitelable' || partner_type === 'whitelabel') && {
        title: 'whitelabel',
        path: PATH_DASHBOARD.whitelableConfig,
        icon: ICONS.whitelable,
      },
      {
        title: 'Notifications',
        path: PATH_DASHBOARD.notifications,
        icon: ICONS.accountSetup,
      },
      // {
      //   title: 'Lead Setup',
      //   path: PATH_DASHBOARD.leadsetup,
      //   icon: <LeaderboardOutlinedIcon />,
      // },
    ],
  },
];

export default navConfig;
